<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm @submit.prevent="login">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <CInput
                  v-model="form.email"
                  placeholder="Email"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="form.password"
                  placeholder="Senha"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton type="submit" color="primary" class="px-4">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0">Esqueceu a senha?</CButton>
                    <CButton color="link" class="d-md-none">Registre-se!</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
            <h2>Não sou cadastrado</h2>
            <p>Pescador, venha fazer parte da plataforma de estudo consertando as redes. Utilize o botão abaixo para se cadastrar e ter acesso a cursos de aprofundamento</p>
            <CButton
              color="primary"
              class="active mt-3"
              @click="register"
            >
              Cadastre-se agora!
            </CButton>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Login',

  data: () => ({
    user: {},
    form: {
      email: "",
      password: ""
    },
  }),

  methods: {
    login() {
      let self = this

      this.$loading(true)
      this.$http.get('/sanctum/csrf-cookie').then(() => {
        this.$http.post('/login', this.form)
        .then(res => {
          if (res.status === 200 || res.status === 201)
          {
            this.$store.commit('set', ['menu', []])
            this.$store.commit('set', ['user', res.data])
            if (res.data.email_verified_at === null)
            {
              this.$router.push({name: 'Verify'})
            } else {
              this.$router.push({name: 'Dashboard'})
            }
          } else {
            this.$loading(false)
            let msg = "Verifique o email e a senha informada"
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: msg,
            })
          }
        })
        .catch(error => {
          this.$loading(false)
          let msg = "Algo errado não está certo";
          if (error.response.status)
          {
            msg = "Não achei esse email e senha"
          }

          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: msg,
          })
        });
      })
    },
    register() {
      this.$router.push({name: 'Register'})
    },
    /*
    getUsuario() {
      this.$http.get('/api/user')
      .then(res => {
        if (res.status === 200)
        {
          console.log(res);
          //this.$router.push({name: 'Home'})
        }
      })
      .catch(error => {
        let msg = "Algo errado não está certo";
        if (error.response.status)
        {
          msg = "Não achei esse email e senha"
        }

        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: msg,
        })
      });
    }*/
  }

}
</script>
